import React from 'react';

import styles from './ShareButton.module.scss';

const ShareButton = ({ icon, linkButtons, onClick }) => {
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick();
    }
  };

  return (
    <div
      className={`${styles.shareButton} ${linkButtons}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={handleKeyPress}
    >
      {icon}
    </div>
  );
};
export default ShareButton;
